import { Controller } from "@hotwired/stimulus";
import { makeMatcher } from "../utils/text_match";

// Drawer lateral droit qui presente l'integralite des champs personnalises
// d'un record et permet de les modifier d'un coup. Charge via turbo_frame
// depuis un lien `data-turbo-frame="cf_panel_frame"`.
export default class extends Controller {
  static targets = ["panel", "search", "body", "item"];

  connect() {
    this._onKey = this._onKey.bind(this);
    document.addEventListener("keydown", this._onKey);
    this._lockBodyScroll(true);
    // Animation slide-in : on retire la classe `enter` au tick suivant pour
    // declencher la transition CSS.
    requestAnimationFrame(() => this.element.classList.add("cf-drawer--open"));
    this._focusFirstInput();
  }

  disconnect() {
    document.removeEventListener("keydown", this._onKey);
    this._lockBodyScroll(false);
  }

  close(event) {
    if (event) event.preventDefault();
    this.element.classList.remove("cf-drawer--open");
    // Laisse l'animation de sortie jouer avant de vider la frame.
    setTimeout(() => {
      const frame = document.getElementById("cf_panel_frame");
      if (frame) frame.innerHTML = "";
    }, 180);
  }

  filter() {
    const matcher = makeMatcher(this.searchTarget.value);
    let visible = 0;
    this.itemTargets.forEach((row) => {
      const name  = row.dataset.cfName  || "";
      const iname = row.dataset.cfInternalName || "";
      const match = matcher(`${name} ${iname}`);
      row.hidden = !match;
      if (match) visible++;
    });

    let emptyHint = this.bodyTarget.querySelector(".cf-drawer__nohit");
    if (visible === 0 && q) {
      if (!emptyHint) {
        emptyHint = document.createElement("div");
        emptyHint.className = "cf-drawer__nohit";
        emptyHint.innerHTML = `<i class="fa-regular fa-face-meh"></i> Aucun champ ne correspond a « ${q.replace(/[<>&"]/g, "")} ».`;
        this.bodyTarget.appendChild(emptyHint);
      }
    } else if (emptyHint) {
      emptyHint.remove();
    }
  }

  _onKey(event) {
    if (event.key === "Escape") this.close(event);
  }

  _lockBodyScroll(lock) {
    if (lock) {
      this._previousOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = this._previousOverflow || "";
    }
  }

  _focusFirstInput() {
    requestAnimationFrame(() => {
      const target = this.element.querySelector('[data-cf-drawer-target="search"]');
      if (target) target.focus();
    });
  }
}
